import React from "react";
import { useMutation } from "@apollo/client";
import mutations from "Shared/mutations";
import queries from "Shared/queries";
import AdminTableRow from "../AdminTableRow/AdminTableRow";
import { UpdateManagerStatusMutation, UpdateManagerStatusMutationVariables } from "generated/graphql";
import { DPManager } from "Shared/types/Admins";

interface AdminTableRowContainerProps {
  admin: DPManager;
  page: number;
}

const AdminTableRowContainer = ({
  admin,
  page,
}: AdminTableRowContainerProps) => {
  const {
    firstName,
    lastName,
    email,
    payGroup,
    permissions,
    status,
    employerId,
    ether,
    locations,
  } = admin;
  const fullName = `${firstName} ${lastName}`;
  const [updateManagerStatusFn] = useMutation<UpdateManagerStatusMutation, UpdateManagerStatusMutationVariables>(
    mutations.UPDATE_MANAGER_STATUS,
    { variables: { id: employerId, enabled: false } }
  );
  const refetchQueries = [
    {
      query: queries.GET_ADMINS_QUERY,
      variables: { page },
    },
  ];
  const handleClick = async () => {
    await updateManagerStatusFn({ refetchQueries });
  };

  const rowProps = {
    fullName,
    permissions,
    handleClick,
    status,
    payGroup,
    locations: locations.items || [],
    email: email || "",
    ether,
  };
  return <AdminTableRow {...rowProps} />;
};
export default AdminTableRowContainer;
